import gql from 'graphql-tag'

export const LIST = gql`
  query claims(
    $companyId: Int
    $claimId: Int
    $critical: Int
    $departmentId: Int
    $employeeId: Int
    $from: String
    $to: String
    $states: [String]
    $offset: Int = 0
    $limit: Int = 1000000
    $mode: RequestMode = MIK_TPRO
  ) {
    claims(
      companyId: $companyId
      claimId: $claimId
      critical: $critical
      departmentId: $departmentId
      employeeId: $employeeId
      from: $from
      to: $to
      states: $states
      offset: $offset
      limit: $limit
      mode: $mode
    )
    {
      id
      name
      billDirection
      comment
      createDate
      critical
      departmentId
      departmentName
      finishedDate
      state
      userId
      userName
    }
  }
`

export const STATS = gql`
  query claims_stats(
    $companyId: Int
    $claimId: Int
    $critical: Int
    $departmentId: Int
    $employeeId: Int
    $from: String
    $to: String
    $states: [String]
    $mode: RequestMode = MIK_TPRO
  ) {
    claims_stats(
      companyId: $companyId
      claimId: $claimId
      critical: $critical
      departmentId: $departmentId
      employeeId: $employeeId
      from: $from
      to: $to
      states: $states
      mode: $mode
    )
    {
      group count
    }
  }
`

export const DETAILS = gql`
  query claimPositions($offset: Int = 0 $limit: Int = 10000 $claimId: Int!) {
    claimPositions(offset: $offset limit: $limit claimId: $claimId) {
      positionId
      nomenclatureId
      nomenclatureName
      unitName
      marketPrice
      amount
      confirmedAmount
      confirmedPrice
      comment
    }

    claimComments(claimId: $claimId offset: $offset limit: $limit) {
      comment
      date
      userId
      userName
    }
}
`
